// @flow strict

import React from 'react';
import { Helmet } from 'react-helmet';
import { injectIntl } from 'react-intl';

// Container
import LoginContainer from 'containers/LoginContainer';

// Types
import type { IntlType } from 'types';

type Props = {
    intl: IntlType,
};

export class Login extends React.PureComponent<Props> {
    render() {
        return (
            <React.Fragment>
                <Helmet>
                    <title>
                        {this.props.intl.formatMessage({
                            id: 'views.Login.helmetTitle',
                        })}
                    </title>
                    <meta
                        name="description"
                        content={this.props.intl.formatMessage({
                            id: 'views.Login.helmetDescription',
                        })}
                    />
                </Helmet>
                <LoginContainer />
            </React.Fragment>
        );
    }
}

export default injectIntl(Login);
